import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function fascicleFormFields(
  translate: TranslateService,
  templateOptions: { label: string; value: string }[]
): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('FASCICLE.NAME'),
        required: true,
      },
    },
  ];
}
